import { fetchWrapperPublic } from "helpers/fetch-wrapper";
import { API_BASE_URL } from "helpers/constants";

export class StatisticsQueries {
    static async getAllStats(): Promise<Response> {
        return await fetchWrapperPublic.get(`${API_BASE_URL}/data/stats/best-selling`);
    }
}